import alt from '../alt';
import CartActions from './cart_actions';

class CartStore {
  constructor() {
    this.resetState();

    this.bindListeners({
      handleCartLoaded: CartActions.CART_LOADED,
    });
  }

  handleCartLoaded(response) {
    this.cart = response;
  }

  resetState() {
    this.cart = null;
  }
}

export default alt.createStore(CartStore, 'CartStore');



// WEBPACK FOOTER //
// ./javascripts/components/cart/cart_store.js